import { lazy } from 'react'
import i18n from 'common/i18n'
import { lazyRetry } from '../help/utils'

const InternalOrder = lazy(() => lazyRetry(() => import('containers/InternalOrder')))
const InternalOrderRegister = lazy(() => lazyRetry(() => import('containers/InternalOrder/register')))

const baseUrl = '/internal-order'

const route = [
  {
    name: i18n.t('routes.internalOrder.index'),
    path: baseUrl,
    main: InternalOrder,
    exact: true,
    permissions: ['ROLE_VISUALIZAR_CADASTRO_OI']
  },
  {
    name: i18n.t('routes.internalOrder.register'),
    path: `${baseUrl}/register`,
    main: InternalOrderRegister,
    exact: true,
    permissions: ['ROLE_EDITAR_CADASTRO_OI']
  },
  {
    name: i18n.t('routes.internalOrder.edit'),
    path: `${baseUrl}/edit/:id`,
    main: InternalOrderRegister,
    exact: true,
    permissions: ['ROLE_EDITAR_CADASTRO_OI']
  }
]

export default route
